import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SizeService {

  baseUrl = environment.baseUrl;
  chartImagePreview: string | ArrayBuffer | null = null;

  size_form = new FormGroup({
    id : new FormControl(null),
    size_name : new FormControl('', [Validators.required]),
    size_code : new FormControl('', [Validators.required]),
    user_id : new FormControl(''),
    status : new FormControl(''),
    created_at : new FormControl(''),
    updated_at : new FormControl(''),
  });

  size_chart_form = new FormGroup({
    id : new FormControl(null),
    chart_name : new FormControl('', [Validators.required]),
    chart_description : new FormControl(''),
    // chart_image : new FormControl(null),
  });

  constructor(private http:HttpClient, 
      private loading : LoadingService,) { }

  sizePoulateForm(rowData: any){
      this.size_form.setValue(_.omit(rowData, 'size_img'));
  }

  sizeChartsPopulateForm(rowData: any){
    //console.log(rowData.chart_image);
    this.chartImagePreview = rowData.chart_image;
    this.size_chart_form.setValue(_.omit(rowData, 'chart_image', 
      'company_id', 'user_id' , 'created_at', 'updated_at', 'deleted_at'));
  }

  get_all_sizes() {
    return this.http.get(this.baseUrl + '/get_all_sizes');
  }

  // get_active_sizes() {
  //   return this.http.get(this.baseUrl + '/get_active_sizes');
  // }

  get_size_charts() {
    return this.http.get(this.baseUrl + '/get_size_charts');
  }

  insert_size(formData: any)
  { 
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('size_name', formData.size_name);
    myFormData.append('size_code', formData.size_code); 
    return this.http.post(this.baseUrl + '/create_size', myFormData, {
      headers: headers
    });
  }

  update_size(formData: any)
  {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('size_name', formData.size_name);
    myFormData.append('size_code', formData.size_code);   
    return this.http.post(this.baseUrl + '/update_size/'+ formData.id, myFormData, {
      headers: headers
    });  
  }

  delete_product_size(id:any) {
    return this.http.get(this.baseUrl + '/delete_size/' + id);
  }

  insert_sizechart(formData: any, chart_image: any)
  {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('chart_name', formData.chart_name);
    myFormData.append('chart_description', formData.chart_description);
    myFormData.append('chart_image', chart_image);    
    return this.http.post(this.baseUrl + '/create_size_chart', myFormData, {
      headers: headers
    });

  }
  
  update_sizechart(formData: any, chart_image: any)
  {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('chart_name', formData.chart_name);
    myFormData.append('chart_description', formData.chart_description);
    myFormData.append('chart_image', chart_image);    
    return this.http.post(this.baseUrl + '/update_size_chart/'+ formData.id, myFormData, {
      headers: headers
    });  
  }

  delete_product_size_chart(id:any) {
    return this.http.get(this.baseUrl + '/delete_size_chart/' + id);
  }

}
